<ngx-qrcode *ngIf="show" [id]="customId" elementType="canvas" [value]="code" [version]="version" cssClass="qr-code"
  errorCorrectionLevel="L">
</ngx-qrcode>